<form novalidate *ngIf="lead" [formGroup]="leadForm" (ngSubmit)="onSubmitForm(leadForm.value)">

  <div class="selected-prompt-wraper" *ngIf="showPrompt && promptAllowed">

    <div class="selected-prompt">
      <div *ngIf="!isPromptFinished">
        <div *ngFor="let lender of availableSelected.lenders; let i=index">
          <div *ngIf="lender.prompt_active">
            <h2 class="title is-size-4-mobile">
              <span>Do you want to Get Rates from {{ lender.bank_name }}?</span>
            </h2>

            <div class="btn-wrapper">
              <label class="checkbox-container">
                <button type="button" class="button green continue is-large has-shadow-small" (click)="continueWith('yes')">
                  <input type="checkbox"  formArrayName="lenders_prompt" (change)="onCheckChange($event)" [value]="lender.id" [checked]="lender.prompt_checked">
                  <span class="checkmark"></span>
                  <span class="btn-main">Yes Get Rates*</span>
                  <i class="fas fa-chevron-right"></i>
                </button>
              </label>
            </div>

            <div>
              <button type="button" class="button continue setno is-large has-shadow-small" (click)="continueWith('no')">
                No&nbsp;&nbsp;&nbsp;&nbsp;
                <i class="fas fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>

        <div style="font-family: Tahoma; font-size: 14px; padding: 4px; margin-top: 40px;">
          *By clicking "Get Rates" above, I am electronically signing this web-form and giving my express written consent for FreeRateUpdate.com LLC and the companies selected (checked) above to contact me at the phone number I have provided for purposes of providing marketing information regarding mortgages and home equity products, even if my number is listed on any company-specific, state, or federal Do-Not-Call list. This may include the use of automatically dialed voice calls and SMS/MMS messages and prerecorded or artificial voice messages. Message and data rates may apply. I acknowledge that there are up to 6 lenders pre-selected in the list above and that I may de-select any or all of them before I submit this web-form. By leaving lenders checked I am affirmatively choosing and consenting to receive mortgage and home equity marketing information from those lenders. To de-select lenders, I understand that I should click the checked box next to the lender’s name. I acknowledge that my consent is not required to obtain mortgage or home equity product marketing from FreeRateUpdate.com LLC or a mortgage or a home equity product from the company or companies listed above.
        </div>

      </div>
      <div *ngIf="isPromptFinished">
        Thank you! We redirect you on result page, please wait some seconds.
      </div>
    </div>
  </div>

  <input type="hidden" formControlName="encryptedLeadId">
  <div class="columns">
    <div class="column">
      <div class="field is-horizontal-mobile">
        <label class="label" for="firstName">First Name</label>

        <div class="control has-icons-left">
          <input class="input" type="text" formControlName="firstName" id="firstName">

          <span class="icon is-left">
            <i class="fas fa-user"></i>
          </span>

          <p class="help is-danger" *ngIf="firstNameControl.errors?.required">First Name is required.</p>
          <p class="help is-danger" *ngIf="firstNameControl.errors?.minlength">First Name must be at least {{ firstNameControl.errors.minlength.requiredLength }} letters.</p>
        </div>
      </div>

      <!-- <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">Subject</label>
        </div>
        <div class="field-body">
          <div class="field">
            <div class="control">
              <input class="input is-danger" type="text" placeholder="e.g. Partnership opportunity">
            </div>
            <p class="help is-danger">
              This field is required
            </p>
          </div>
        </div>
      </div> -->

      <div class="field is-horizontal-mobile">
        <label class="label" for="lastName">Last Name</label>

        <div class="control has-icons-left">
          <input class="input" type="text" formControlName="lastName" id="lastName">

          <span class="icon is-left">
            <i class="fas fa-user"></i>
          </span>

          <p class="help is-danger" *ngIf="lastNameControl.errors?.required">Last Name is required.</p>
          <p class="help is-danger" *ngIf="lastNameControl.errors?.minlength">Last Name must be at least {{ lastNameControl.errors.minlength.requiredLength }} letters.</p>
        </div>
      </div>

      <div class="field is-horizontal-mobile">
        <label class="label" for="phone">Phone</label>

        <div class="control has-icons-left">
          <input class="input" type="phone" formControlName="phone" id="phone" [imask]="phoneMask">

          <span class="icon is-left">
            <i class="fas fa-phone"></i>
          </span>

          <p class="help is-danger" *ngIf="phoneControl.errors?.required">Phone Number is required.</p>
          <p class="help is-danger" *ngIf="phoneControl.errors?.pattern">Invalid Phone Number.</p>
        </div>
      </div>

      <div class="field lender-checkboxes" *ngIf="selectedEnabled && availableSelected.lenders.length > 0">
        <h4 class="get_lendes_title" style="margin-bottom: 6px;">Get Rates from Checked Lenders <span>(Click <input type="checkbox" checked style="margin: 0px"> to Uncheck)</span></h4>
        <div class="columns">
            <div class="column">
              <div class="control" *ngFor="let lender of availableSelected.lenders; let i=index">
                <label class="checkbox-container">
                  <input type="checkbox" id = "leadid_tcpa_brandname_0{{i+1}}" formArrayName="lenders" (change)="onCheckChange($event)" [value]="lender.id" [checked]="lender.checked">
                    <span class="checkmark"></span>
                    <label for = "leadid_tcpa_brandname_0{{i+1}}">{{ lender?.bank_name }}</label>
                </label>
              </div>
            </div>
        </div>
      </div>
      <div class="field lender-checkboxes has-text-centered mb-3 mt-4" *ngIf="availableSelected.lead_id == 0 && selectedEnabled">
        <b><i class="fa fa-spinner fa-spin" aria-hidden="true"></i> Loading available lenders...</b>
      </div>

      <div class="field">
        <div class="control">
          <input type="hidden" name="universal_leadid" id="leadid_token" value="" />
          <button type="submit"
            class="button is-success is-fullwidth is-size-4 is-size-5-mobile has-text-weight-black has-shadow-large"
            [disabled]="!leadForm.valid || disableSubmit || (availableSelected.lead_id == 0 && selectedEnabled)">Get Rates<span *ngIf="selectedEnabled">*</span> &#12297;</button>
        </div>
      </div>

      <div class="field">
        <p class="tcpa is-size-7 has-text-grey-dark"  *ngIf="selectedEnabled">
          <input type="hidden" id="leadid_tcpa_disclosure_form">
          <label for="leadid_tcpa_disclosure_form">
            *By clicking "Get Rates" above, I am electronically signing this web-form and giving my express written consent for FreeRateUpdate.com LLC and the companies selected (checked) above to contact me at the phone number I have provided for purposes of providing marketing information regarding mortgages and home equity products, even if my number is listed on any company-specific, state, or federal Do-Not-Call list. This may include the use of automatically dialed voice calls and SMS/MMS messages and prerecorded or artificial voice messages. Message and data rates may apply. I acknowledge that there are up to 6 lenders pre-selected in the list above and that I may de-select any or all of them before I submit this web-form. By leaving lenders checked I am affirmatively choosing and consenting to receive mortgage and home equity marketing information from those lenders. To de-select lenders, I understand that I should click the checked box next to the lender’s name. I acknowledge that my consent is not required to obtain mortgage or home equity product marketing from FreeRateUpdate.com LLC or a mortgage or a home equity product from the company or companies listed above.
          </label>
        </p>

        <p class="tcpa is-size-7 has-text-grey-dark has-text-left" style="padding: 0 5px;" *ngIf="!selectedEnabled">
          <input type="hidden" id="leadid_tcpa_disclosure_form">
          <label for="leadid_tcpa_disclosure_form" class="disclosure-text">
            We take your privacy seriously. By clicking the button above, You agree that we can share your personal data with third parties, such as our mortgage partners, service providers and other affiliates, and that we can use this data for marketing and analytics, and to make your experience easier. you are also providing your<b>express written consent</b> to have your information shared and to be matched with up to five <a *ngIf="!fruLocalKiosk" href="/approved-lenders" target="_new" rel="nofollow">approved lenders</a><a *ngIf="fruLocalKiosk" (click)="closeModal()">approved lenders</a> and for them, or their authorized third party, to call you at the number you have provided including through automated means such as autodialing, text SMS/MMS (charges may apply), and prerecorded messaging, and/or via email, even if your telephone number is a cellular phone number or on a corporate, state, or the National Do Not Call Registry, and you agree to our Privacy Policy <a *ngIf="!fruLocalKiosk" href="/privacy" target="_new" rel="nofollow">Privacy Policy</a><a *ngIf="fruLocalKiosk" (click)="closeModal()">Privacy Policy</a>. Consent is not required as a condition to utilize FreeRateUpdate's services, you may choose to use our services by calling 855-315-7283. Consent is not contingent on the purchase and/or use of any services being offered by a Lender.
          </label>
        </p>

        <p class="tcpa-2 is-size-7 has-text-grey-dark has-text-left" style="padding: 0 5px;" *ngIf="!selectedEnabled">
          <label class="disclosure-text" for="leadid_tcpa_disclosure_form">
            Message frequency varies. Call 855-315-7283 for help. Text STOP to cancel. <a *ngIf="!fruLocalKiosk" href="/privacy_policy.php" rel="nofollow" target="_blank">Terms and Conditions</a><a *ngIf="fruLocalKiosk" (click)="closeModal()">Terms and Conditions</a>
          </label>
        </p>

        <p class="is-flex is-flex-centered">
            <img src="/assets/images/bbb-a-plus-rating.gif" alt="BBB A+ Rated">
        </p>
      </div>
    </div>
  </div>
</form>
